<template>
    <v-row>
      <v-progress-linear v-if="loading" indeterminate color="blue darken-2"></v-progress-linear>
      <v-col lg="12" class="page-title">
        <v-card class="mx-auto mb-1"  flat>
          <v-card-title>
            {{ title }}
            <span v-if="data">- {{ data.name }} - {{ data.code }}</span>
            <v-spacer></v-spacer>
            
            <v-checkbox
              v-model="completed"
              label="COMPLETED"
              @click="toggleCompleted()"
              class="grey-lighten-3 ma-2"
              dense
            ></v-checkbox>
            <v-checkbox
              v-model="planning"
              label="PLANNING"
              @click="togglePlanning()"
              class="grey-lighten-3 ma-2"
              dense
            ></v-checkbox>
            <v-checkbox
              v-model="pending"
              label="PENDING"
              @click="togglePending()"
              class="grey-lighten-3 ma-2"
              dense
            ></v-checkbox>
            <v-checkbox
              v-model="inprogress"
              label="IN-PROGRESS"
              @click="toggleInprogress()"
              class="grey-lighten-3 ma-2"
              dense
            ></v-checkbox>
            <v-checkbox
              v-model="hold"
              label="HOLD"
              @click="toggleHold()"
              class="grey-lighten-3 ma-2"
              dense
            ></v-checkbox>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </template>
  
  <script>
  export default {
    name: "StatusFilter",
    props: ["title", "loading", "data"],
    data() {
      return {
        sttr: "",
        completed: false,
        pending: false,
        inprogress: false,
        hold: false,
        planning: false,
      };
    },
    watch: {
      completed: function(newRole, oldRole) {
        if (newRole !== oldRole) {
          this.emitSelectedFilters();
        }
      },

      planning: function(newRole, oldRole) {
        if (newRole !== oldRole) {
          this.emitSelectedFilters();
        }
      },

      pending: function(newRole, oldRole) {
        if (newRole !== oldRole) {
          this.emitSelectedFilters();
        }
      },

      inprogress: function(newRole, oldRole) {
        if (newRole !== oldRole) {
          this.emitSelectedFilters();
        }
      },

      hold: function(newRole, oldRole) {
        if (newRole !== oldRole) {
          this.emitSelectedFilters();
        }
      },
    },
    methods: {
      emitSelectedFilters() {
        this.$emit("statusText", this.sttr);
      },

      toggleCompleted(){
        if (this.sttr === ""){
          if (this.completed){
            this.sttr = 'COMPLETED'
          }else{
            this.sttr = "";
          }
        }else{
          if (this.completed){
            this.sttr = this.sttr+',COMPLETED';
          }else{
            const parts = this.sttr.split(',');
            const indexToRemove = parts.indexOf('COMPLETED');
            if (indexToRemove !== -1) {
              parts.splice(indexToRemove, 1);
            }
            this.sttr = parts.join(',');
          }
        }
        
      },

      togglePlanning(){
        if (this.sttr === ""){
          if (this.planning){
            this.sttr = 'PLANNING'
          }else{
            this.sttr = "";
          }
        }else{
          if (this.planning){
            this.sttr = this.sttr+',PLANNING';
          }else{
            const parts = this.sttr.split(',');
            const indexToRemove = parts.indexOf('PLANNING');
            if (indexToRemove !== -1) {
              parts.splice(indexToRemove, 1);
            }
            this.sttr = parts.join(',');
          }
        }
        
      },

      togglePending(){
        if (this.sttr === ""){
          if (this.pending){
            this.sttr = 'PENDING'
          }else{
            this.sttr = "";
          }
        }else{
          if (this.pending){
            this.sttr = this.sttr+',PENDING';
          }else{
            const parts = this.sttr.split(',');
            const indexToRemove = parts.indexOf('PENDING');
            if (indexToRemove !== -1) {
              parts.splice(indexToRemove, 1);
            }
            this.sttr = parts.join(',');
          }
        }
        
      },

      toggleInprogress(){
        if (this.sttr === ""){
          if (this.inprogress){
            this.sttr = 'IN-PROGRESS'
          }else{
            this.sttr = "";
          }
        }else{
          if (this.inprogress){
            this.sttr = this.sttr+',IN-PROGRESS';
          }else{
            const parts = this.sttr.split(',');
            const indexToRemove = parts.indexOf('IN-PROGRESS');
            if (indexToRemove !== -1) {
              parts.splice(indexToRemove, 1);
            }
            this.sttr = parts.join(',');
          }
        }
        
      },

      toggleHold(){
        if (this.sttr === ""){
          if (this.hold){
            this.sttr = 'HOLD'
          }else{
            this.sttr = "";
          }
        }else{
          if (this.hold){
            this.sttr = this.sttr+',HOLD';
          }else{
            const parts = this.sttr.split(',');
            const indexToRemove = parts.indexOf('HOLD');
            if (indexToRemove !== -1) {
              parts.splice(indexToRemove, 1);
            }
            this.sttr = parts.join(',');
          }
        }
        
      },

      
    }
  };
  </script>
  
  <style>
  .page-title .v-card__title {
    padding: 0;
    padding-left: 15px;
    padding-right: 15px;
  }
  
  .page-title fieldset {
    color: #ddd !important;
  }
  </style>
  